if (!customElements.get("shipping-calculator")) {
    class ShippingCalculator extends HTMLElement {
        constructor() {
            super();
            this.zip = this.querySelector(".js-zip-input");
            this.zip.addEventListener("keydown", this.handleZipKeydown.bind(this));
            this.button = this.querySelector("button");
            this.button.addEventListener("click", this.handleSubmit.bind(this));
        }

        init() {
            this.country = this.querySelector(".js-country-select");
            this.province = this.querySelector(".js-province-select");
            this.rates = this.querySelector(".js-rates");
            this.errors = this.querySelector(".js-errors");
            this.initialised = !0;
        }

        async handleSubmit(evt) {
            evt.preventDefault();
            this.initialised || this.init();
            this.errors.hidden = !0;
            this.rates.hidden = !0;
            this.button.disabled = !0;
            this.button.classList.add("is-loading");

            const params = `shipping_address[zip]=${this.zip.value}&shipping_address[country]=${this.country.value}&shipping_address[province]=${this.province.value}`;
            
            try {
                const response = await fetch(`${theme.routes.cart}/shipping_rates.json?${params}`);
                const data = await response.json();

                response.ok ? this.showRates(data) : this.showErrors(data);
            } catch (error) {
                console.log(error);
            } finally {
                this.button.classList.remove("is-loading");
                this.button.disabled = !1;
            }
        }

        handleZipKeydown(evt) {
            if (evt.key === "Enter") {
                evt.preventDefault();
                this.handleSubmit(evt);
            }
        }

        showRates(data) {
          const headingEl = this.rates.querySelector(".js-rates-heading"),
                textEl = this.rates.querySelector(".js-rates-text");
      
          // Limpa o conteúdo anterior
          textEl.innerHTML = "";
      
          // Verifica se existem taxas de envio
          if (data.shipping_rates && data.shipping_rates.length) {
              const headingLocaleStr = data.shipping_rates.length === 1 ? "singleRate" : "multipleRates";
              let rates = "";
      
              // Itera sobre as taxas de envio e exibe as informações
              data.shipping_rates.forEach(rate => {
                  const formattedRate = theme.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, rate.price);
      
                  // Pega a data de entrega (campo `delivery_date`)
                  let deliveryDate = "";
                  if (rate.delivery_date) {
                      const deliveryDateObj = new Date(rate.delivery_date);
                      const today = new Date();
                  
                      // Zera hora/min/seg para comparação só por dia
                      deliveryDateObj.setHours(0, 0, 0, 0);
                      today.setHours(0, 0, 0, 0);
                      const diffInMs = deliveryDateObj - today;
                      const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));
                      if (diffInDays > 0) {
                         deliveryDate = ` - Entrega em ${diffInDays} ${diffInDays === 1 ? 'dia útil' : 'dias úteis'}` ;
                      }else {
                          deliveryDate = ` - Entrega em 1 dia útil`;
                      }
                  }
      
                  // Adiciona a taxa e a data de entrega à lista
                  rates += `<li>${rate.name}: ${formattedRate}${deliveryDate}</li>`;
              });
      
              headingEl.hidden = !1;
              headingEl.textContent = theme.strings.shippingCalculator[headingLocaleStr];
              textEl.innerHTML = `<ul class="styled-list">${rates}</ul>`;
          } else {
              headingEl.hidden = !0;
              textEl.innerHTML = theme.strings.shippingCalculator.noRates;
          }
      
          this.rates.hidden = !1;
      }




        showErrors(data) {
            let errors = "";
            Object.keys(data).forEach(key => {
                errors += `<li>${data[key]}</li>`;
            });

            this.errors.querySelector(".js-errors-text").innerHTML = `<ul class="styled-list">${errors}</ul>`;
            this.errors.hidden = !1;
        }
    }

    customElements.define("shipping-calculator", ShippingCalculator);
}


